import { Panel } from '../core/Panel';
import { Sim, ProgressionSystem, UNLOCKS } from '../../game/simulation';

export class SkillsPanel extends Panel {
  constructor(sim: Sim) { super(sim); }
  id() { return 'skills'; }
  title() { return 'Skills'; }
  hashInputs() {
    const s = this.sim.state;
    return JSON.stringify({ xp: s.prog.xp, lv: s.prog.level });
  }
  body() {
    const s = this.sim.state;
    const lv = s.prog.level;
    const xpPrev = ProgressionSystem.xpForCurrent(s);
    const xpNext = ProgressionSystem.xpForNext(s);
    const pct = xpNext > xpPrev ? Math.floor(((s.prog.xp - xpPrev) / (xpNext - xpPrev)) * 100) : 100;
    return `
      <div class="ui-section">
        <div class="ui-row"><span>Level</span><strong>${lv}</strong></div>
        <div class="ui-row"><span>XP</span><strong>${s.prog.xp}/${xpNext > xpPrev ? xpNext : 'MAX'}</strong></div>
        <div class="ui-bar"><div class="ui-bar__fill" style="width:${pct}%"></div><div class="ui-bar__label">${pct}%</div></div>
      </div>
      <div class="ui-section">
        <div class="ui-section__title">Unlocks</div>
        ${UNLOCKS.map(u => `
          <div class="ui-unlock ${lv >= u.level ? 'done' : ''}">
            <span class="ui-unlock__dot"></span>
            <span>LV${u.level} — ${u.label}</span>
          </div>`).join('')}
      </div>
    `;
  }
}
